<template>  
  <v-content class="pa-0 ">
    <v-row justify="center" no-gutters> 
      <v-col cols="12" xl="6" lg="6" md="8" sm="8">
        
        <v-snackbar v-model="snackbar" :timeout="4000" :color="color" top> {{text}}
          <v-btn color="white" text @click="snackbar = false" > Cerrar  </v-btn>
        </v-snackbar>

        <v-card-text align="left">
          <v-card-actions>
            <v-card-title class="font-weight-black headline ">
              {{ nModo===1?'Nuevo Usuario':'Editar Usuario'}} 
            </v-card-title>
            <v-spacer></v-spacer>
            <v-btn color="secondary" dark large icon onClick="history.go(-1); return false;">
              <v-icon large >mdi-arrow-left-thick</v-icon>
            </v-btn>
          </v-card-actions>
            <v-form 
              ref="form" 
              v-model="valid"
              :lazy-validation="lazy" >
              <v-row>
                <v-col cols="12">
                <v-select 
                  v-model="nivel" :items="niveles" outlined prepend-icon="call_split"
                  label="Nivel" return-object hide-details dense item-text="nombre" item-value="clave"
                ></v-select>
              </v-col>
                <v-col cols="12" sm="6"> 
                  <v-row> 
                    <v-col cols="12" >
                      <v-text-field 
                        :rules="nameRules"
                        v-model="nombre" 
                        color="secondary"
                        clearable
                        hide-details 
                        prepend-icon="person" 
                        label="Nombre de usuario" 
                        outlined dense 
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field 
                        :rules="nameRules"
                        v-model="apellidos" 
                        color="secondary"
                        clearable
                        hide-details 
                        prepend-icon="person" 
                        label="apellidos" 
                        outlined dense 
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" >
                      <v-text-field 
                        v-model.number="telmovil" 
                        color="secondary"
                        clearable
                        hide-details 
                        prepend-icon="phone" 
                        label="Telefono celular" 
                        outlined dense 
                        :disabled="NIVEL"
                        type="number"
                        required
                        :rules="[v => !!v || 'Item is required']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field 
                        v-model="email" 
                        color="secondary"
                        clearable
                        hide-details 
                        prepend-icon="email" 
                        label="Correo" 
                        outlined dense 
                        required
                        :rules="emailRules"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="nModo===1">
                      <v-text-field
                        v-model="password"
                        prepend-icon="lock"
                        :append-icon="show1 ? 'visibility' : 'visibility_off'"
                        :type="show1 ? 'text' : 'password'"
                        label="Contraseña"
                        counter
                        @click:append="show1 = !show1"
                        dense
                        outlined
                        color="secondary"
                        clearable
                        hide-details
                        required
                        :rules="[v => !!v || 'Item is required']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="nModo===1">
                      <v-text-field
                        v-model="password2"
                        prepend-icon="lock"
                        :append-icon="show2 ? 'visibility_off' : 'visibility'"
                        :type="show2 ? 'text' : 'password'"
                        label="Confirma la contraseña"
                        @click:append="show2 = !show2"
                        outlined
                        color="secondary"
                        clearable
                        hide-details
                        dense
                        required
                        :rules="[v => !!v || 'Item is required']"
                      ></v-text-field>
                    </v-col>

                    <v-card-actions class="mx-9">
                      <v-spacer></v-spacer>
                      <v-btn small  color="success"  @click="cambiaPassword = !cambiaPassword" v-if="cambiaPassword && nModo ==2"> Cambiar Contraseña	</v-btn>
                      <v-btn small  color="error" dark @click="cambiaPassword = !cambiaPassword" v-if="cambiaPassword == false && nModo ==2"> Cancelar </v-btn>
                    </v-card-actions>

                    <v-card-text v-if="!cambiaPassword">
                      <v-text-field
                        v-model="password"
                        prepend-icon="lock"
                        :append-icon="show1 ? 'visibility_off' : 'visibility'"
                        :type="show1 ? 'text' : 'password'"
                        label="Contraseña"
                        clearable
                        outlined
                        dense
                        @click:append="show1 = !show1"
                      ></v-text-field>
                      
                      <v-text-field
                        v-model="password2"
                        prepend-icon="lock"
                        :append-icon="show2 ? 'visibility_off' : 'visibility'"
                        :type="show2 ? 'text' : 'password'"
                        label=" Confirmar Contraseña"
                        clearable
                        outlined
                        dense
                        @click:append="show2 = !show2"
                      ></v-text-field>
                    </v-card-text>

                  </v-row>
                </v-col>
                <v-col cols="12" sm="6"> 
                  <v-row>
                    <v-col cols="12" >
                      <v-text-field 
                        v-model="empresa" 
                        prepend-icon="domain" 
                        label="Empresa" 
                        outlined dense 
                        color="secondary"
                        clearable
                        hide-details
                        :disabled="NIVEL"
                        required
                        :rules="[v => !!v || 'Item is required']"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" >
                      <v-text-field 
                        v-model.number="telempresa" 
                        prepend-icon="contact_phone" 
                        label="Telefono de empresa" 
                        outlined dense 
                        type="number"
                        color="secondary"
                        clearable
                        hide-details
                        :disabled="NIVEL"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" >
                      <v-text-field 
                        prepend-icon="account_balance_wallet" 
                        label="Modelo de la maquina" 
                        outlined dense 
                        color="secondary"
                        clearable
                        hide-details
                        :disabled="NIVEL"
                        v-model="modmaquina"
                        required
                        :rules="[v => !!v || 'Item is required']"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" >
                      <v-text-field 
                        v-model="matserie" 
                        prepend-icon="format_list_numbered_rtl" 
                        label="Matricula/Serie" 
                        outlined dense 
                        color="secondary"
                        clearable
                        hide-details
                        :disabled="NIVEL"
                        required
                        :rules="[v => !!v || 'Item is required']"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-4" fab small dark @click="cambiaEstatus(2)" v-if="estatus!=2">
                          <v-icon >how_to_reg</v-icon>
                        </v-btn> 
                        <v-btn color="orange darken-4" fab small dark @click="cambiaEstatus(0)" v-if="estatus!=0" >
                          <v-icon >mdi-account-off</v-icon>
                        </v-btn> 
                         <v-btn color="red darken-4" fab small dark @click="cambiaEstatus(1)" v-if="estatus!=1">
                          <v-icon >mdi-account-lock</v-icon>
                        </v-btn> 
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          <v-card-actions> <v-spacer></v-spacer>
            <v-btn  small color="secondary" 
              @click="validarExistencia()" 
              v-if="nModo===1 &&  nivel.clave != 'ADMIN' || nModo===1 &&  nivel.clave != 'SUPERVISOR'" :disabled="!valid">
              Guardar Información
            </v-btn>
            <v-btn  small color="secondary" 
              @click="validarExistencia()" 
              v-if="nModo===1 && nivel.clave == 'ADMIN' || nModo===1 && nivel.clave == 'SUPERVISOR'">
              Guardar Información
            </v-btn>
            <v-btn  small color="secondary" @click="ActualizaUsuario()" v-if="nModo===2">
            Actualizar Información
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-col>
    </v-row>
  </v-content>
</template>

<script>
  import {mapActions , mapGetters} from 'vuex'
  var accounting = require("accounting");
  var md5     = require('md5')
  export default {   
    data () {
      return {
        valid:true,
        lazy: false,

        show: false,
        show1: false,
        show2: false,
        nModo: 0,
        passwordActual:'',
        cambiaPassword:true,

        nivel:{ clave:'', nombre:''},
        niveles: [{clave:'ADMIN', nombre:'Administrador'},{clave:'USUARIO',nombre:'Cliente'},{clave:'SUPERVISOR',nombre:'Supervisor'}],
        password:'',
        password2:'',
      
        snackbar: false,
        color : 'red darken-4',
        text:'',
        // VARIABLES
        id: null,
        nombre:'',
        apellidos:'',
        telmovil:'',
        email:'',
        empresa:'',
        telempresa:'',
        modmaquina:'',
        matserie:'',
        estatus:0,

        nameRules: [
          v => !!v || 'Name is required',
          v => (v && v.length <= 60) || 'Name must be less than 10 characters',
        ],
        email: '',
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        

      }
    },

    created () {
      this.idusuariosweb = this.$route.params.idusuariosweb

      if (this.idusuariosweb !== undefined){
        this.nModo = 2
        this.cargarinfo(this.idusuariosweb) 
        this.readonly = true    
      } else {
        this.nModo = 1
      }     

      this.nModo == 1 ? (this.modoText = 'Nuevo Usuario'):(this.modoText = 'Editar usuario')
    },

    computed:{
      NIVEL(){
        return this.nivel.clave === 'ADMIN'? true:false;
      }
    },

    methods:{
      ...mapActions('Login',['validarUser']),
      ...mapActions('Login',['GetInfoUser' ,]),
      // CARGAR INFO 
      
      cargarinfo(id){
        this.$http.get('users/' + id).then(response => { 
        console.log('usuarios',response.body)
          this.id         = response.body.idusuariosweb;
          this.nombre     = response.body.nombre;
          this.apellidos  = response.body.apellidos;
          this.telmovil   = response.body.telmovil;
          this.email      = response.body.email;
          this.passwordActual   = response.body.password;
          this.empresa    = response.body.empresa;
          this.telempresa = response.body.telempresa;
          this.modmaquina = response.body.modmaquina;
          this.matserie   = response.body.matserie;
          this.nivel      = { clave:  response.body.nivel, 
                              nombre: response.body.nivel ==='ADMIN'?'Administrador':'Cliente'}
          this.estatus    = response.body.estatus;
          
        }).catch(error=>{
            console.log(error)
        })

      },

      validarExistencia(){

        var md5 = require('md5');
        var usuario = {
          nombre    : this.nombre, 
          apellidos : this.apellidos,
          empresa   : this.empresa,
          telempresa: this.telempresa,
          telmovil  : this.telmovil,
          email     : this.email, 
          modmaquina: this.modmaquina,
          matserie  : this.matserie,
          password  : md5(this.password),
          nivel     : this.nivel.clave,
          estatus   : 0
        }

        this.$http.post('registro', usuario).then(response=>{
          if(!response.body.message){
            this.enviarCorreo(response.body)
          }else{
            this.snackbar=true; this.text=response.body.message;// SI EL USUARIO YA EXISTE MUESTRO MENSAJE
          }
        }).catch(err =>{ console.log('error', error) })
      },

       enviarCorreo(req){
        var url = 'https://support-smipack.com/#/activarusuario/'
        var payload = {
          nombre:       req.nombre,
          correo:       req.email,
          url:          url + req.id
        }

        this.$http.post('correos.send',  payload).then(respuesta=>{ 
          this.text = 'Hemos envíado un correo de validación de usuario a tu cuenta.'
          this.color = 'green darken-4'
          this.snackbar = true;
          this.correoEnviado = true;

        }).catch(error=>{
          console.log('error',error)
        })
      },

      ActualizaUsuario(){
        
        const payload = { id: this.id,
                          nombre     : this.nombre,
                          apellidos  : this.apellidos,
                          telmovil   : this.telmovil,
                          email      : this.email,
                          password   : this.cambiaPassword ? this.passwordActual:md5(this.password),
                          empresa    : this.empresa,
                          telempresa : this.telempresa,
                          modmaquina : this.modmaquina,
                          matserie   : this.matserie,
                          nivel      : this.nivel.clave
                        }
        console.log('payload',payload)

        this.$http.post('update.usuario', payload).then( response => {
          this.snackbar = true
          this.color = "blue lighten-3"
          this.text = response.body
          this.cargarinfo(this.id)
        }).catch(error => {
          console.log(error.body)
        })
      },

      cambiaEstatus(estatus){
        const payload = { id: this.id  , estatus: estatus }
        this.$http.post('cambia.estatus',payload).then(response =>{
          this.snackbar=true; this.text=response.body; this.color="green"
          this.cargarinfo(this.id)
        }).catch(err=>{
          console.log('errr',err)
        })
      },

    }
  };
</script>




